export const PDP_LOCIZE = {
  PDP_EARN_CASHBACK_PERK: {
    key: 'PDP_EARN_CASHBACK_PERK',
    text: 'Get it now and earn up to %d Cashback',
  },
  PDP_EARN_CASHBACK_NON_PERK: {
    key: 'PDP_EARN_CASHBACK_NON_PERK',
    text: 'Earn %d as a Pomelo Perks* member',
  },
  PDP_SIZE_OPTIONS_MESSAGE: {
    key: 'PDP_SIZE_OPTIONS_MESSAGE',
    text: 'We adjust the size to run 1 size smaller. Please check size guide before ordering.',
  },
  PDP_ITEM_LIMIT_WARNING_MESSAGE: {
    key: 'PDP_ITEM_LIMIT_WARNING_MESSAGE',
    text: 'Oops! You have already added the maximum number of items in your bag. Please check out or remove some items to make space.',
  },
}

export default { PDP_LOCIZE }
